export const EVENT_ADD_HOUR = 6;